define('notificationCenter',[
  'module',
  'settings',
  'underscore',
  'jquery',
  'logger',
  'marionette',
  'rolesMixin',
  'reconnectingSocket',
  'notify'
], function (module, Settings, _, $, Logger, Marionette, RolesMixin, ReconnectingSocket) {
  'use strict';

  var events = {
    DELETE_ORDER: 'notificationCenter:deleteOrder',
    CHANGE_INFO_ORDER: 'notificationCenter:changeInfoOrder',
    CHANGE_INFO_TICKET: 'notificationCenter:changeInfoTicket',
    // Sales / support inbox items changed: {content: {items: [{secId, inboxType, status, removed}]}}.
    SALES_INBOX_ITEM_CHANGED: 'notificationCenter:changeInfoSalesInboxItem',
    NEW_VECTORISATION_TICKET_MESSAGE: 'notificationCenter:newVectorizeTicketMessage',
    NEW_VECTORISATION_TICKET: 'notificationCenter:newVectorizeTicket',
    NEW_CONVERSION_TICKET_MESSAGE: 'notificationCenter:newConversionTicketMessage',
    NEW_CONVERSION_TICKET: 'notificationCenter:newConversionTicket',
    EMAILS_GMAIL_API_MESSAGE_ADDED: 'notificationCenter:EMAILS_GMAIL_API_MESSAGE_ADDED',
    EMAILS_GMAIL_API_MESSAGE_DELETED: 'notificationCenter:EMAILS_GMAIL_API_MESSAGE_DELETED',
    EMAILS_GMAIL_API_MESSAGE_LABELS_ADDED: 'notificationCenter:EMAILS_GMAIL_API_MESSAGE_LABELS_ADDED',
    EMAILS_GMAIL_API_MESSAGE_LABELS_REMOVED: 'notificationCenter:EMAILS_GMAIL_API_MESSAGE_LABELS_REMOVED',
    CHAT_SESSION_STARTED: 'notificationCenter:CHAT_SESSION_STARTED',
    CHAT_SESSION_CLAIMED: 'notificationCenter:CHAT_SESSION_CLAIMED',
    CHAT_SESSION_RELEASED: 'notificationCenter:CHAT_SESSION_RELEASED',
    CHAT_SESSION_RESOLVED: 'notificationCenter:CHAT_SESSION_RESOLVED',
    CHAT_MESSAGE_ADDED: 'notificationCenter:CHAT_MESSAGE_ADDED',
     CHAT_SESSION_PAGE_CHANGED: 'notificationCenter:CHAT_SESSION_PAGE_CHANGED',
    CHAT_SESSION_FILE_UPLOAD_CHANGED: 'notificationCenter:CHAT_SESSION_FILE_UPLOAD_CHANGED',
    CHAT_SESSION_DELETED: 'notificationCenter:CHAT_SESSION_DELETED',
    AI_CHAT_MESSAGE_ADDED: 'notificationCenter:AI_CHAT_MESSAGE_ADDED',
    AI_CHAT_JOB_STATUS: 'notificationCenter:AI_CHAT_JOB_STATUS',
    AI_CHAT_TURN_PROGRESS: 'notificationCenter:AI_CHAT_TURN_PROGRESS'
  };

  var instance = null;

  var NotificationCenter = Marionette.Object.extend({

    cAccountSecId: null,
    request: null,
    connection: null,

    // Built on each (re)connection: the token may have been renewed meanwhile.
    webSocketUrl: function () {
      var user = Settings.get('currentUser');
      if (!user || !this.cAccountSecId) {
        return null;
      }
      return Settings.compuzzAwsWs + '?cAccountUid=' + this.cAccountSecId + '&user=' +
        user.logonId + '&userSecId=' + user.secId + '&tokenId=' + Settings.get('tokenId');
    },

    subscribe: function (cAccountSecId) {
      if (!this.connection) {
        this.connection = new ReconnectingSocket({
          url: _.bind(this.webSocketUrl, this),
          onMessage: _.bind(this.onMessage, this)
        });
      }
      if (this.cAccountSecId !== cAccountSecId) {
        this.cAccountSecId = cAccountSecId;
        this.connection.connect();
      }
    },

    unSubscribe: function () {
      // Forget the account so logging back into the same one reconnects.
      this.cAccountSecId = null;
      if (this.connection) {
        this.connection.disconnect();
      }
    },

    onMessage: function (response) {
      try {
        var message = JSON.parse(response.data);

        // Outer-type listeners (e.g. 'newVectorizeTicket'). When matched
        // we treat the dispatch as fully handled by the subscribed view —
        // no toast fallback — preserving the historical behaviour for
        // those types.
        if (this._events && this._events['notificationCenter:' + message.type]) {
          this.triggerMethod('notificationCenter:' + message.type, message);
          return;
        }

        // Inner-type listeners (the wrapped 'notification' shape that
        // carries CHAT_*, ORDER_COMMENT_TAGGED, etc.). We still trigger
        // them so views can refresh, but we ALSO fall through to
        // processNotification so wrapped-notification toasts stay
        // centralised in `case 'notification':` regardless of whether a
        // view happens to be subscribed.
        if (this._events && message && message.content && message.content.content &&
            message.content.content.type &&
            this._events['notificationCenter:' + message.content.content.type]) {
          this.triggerMethod('notificationCenter:' + message.content.content.type, message);
        }

        if (!Settings.get('cAccountRoles')[RolesMixin.VECTORIZATOR] ||
          Settings.get('cAccountRoles')[RolesMixin.VECTORIZATOR_VIEW_ALL]) {
          this.processNotification(message);
        }
      } catch (e) {
        console.log(e);
      }
    },

    processNotification: function (notification) {
      switch (notification.type) {
        case 'newVectorizeTicket':
          this.displayNotification(_.i18n('notification.newvectorizeticket'), notification.content.name,
            '#vectorization/' + notification.content.secId, 5000);
          break;
        case 'newVectorizeTicketMessage':
          this.displayNotification(_.i18n('notification.newvectorizeticketmessage'), notification.content.content,
            '#vectorization/' + notification.content.ticketSecId, 5000);
          break;
        case 'newConversionTicket':
          this.displayNotification(_.i18n('notification.newconversionticket'), notification.content.name,
            '#vectorization/' + notification.content.secId, 5000);
          break;
        case 'newConversionTicketMessage':
          this.displayNotification(_.i18n('notification.newconversionticketmessage'), notification.content.content,
            '#vectorization/' + notification.content.ticketSecId, 5000);
          break;
        case 'MissingBillingInfo':
          /*
          this.displayNotification(_.i18n('notification.missingBillingInfo.title'),
              _.i18n('notification.missingBillingInfo.message'),
              '#caccount/' +  Settings.get('currentCAccount').secId, 5000, 'danger', true);
          */
          break;
        case 'notification':
          switch (notification.content.content.type) {
            case 'ORDER_COMMENT_MODIFIED_TAGGED':
            case 'ORDER_COMMENT_TAGGED':
              {
                // When the tag came from a group mention, `groupName` carries
                // the group the recipient belongs to — show it in the toast.
                var orderTaggedVia = '';
                if (notification.content.content.groupName) {
                  orderTaggedVia = ' (' + _.i18n('common.viaGroup', null, 'via') + ' @' +
                      notification.content.content.groupName + ')';
                }
                this.displayNotification(_.i18n('notifications.orderCommentTagged'),
                    notification.content.content.initiator.firstName +
                    ' ' +
                    notification.content.content.initiator.lastName + ' ' +
                    _.i18n('common.taggedYou') + orderTaggedVia + ' ' + notification.content.content.data.poi,
                    '#orders/'+notification.content.content.data.poi+'/details', null, null, false, notification.tag);
              }
              break;
            case 'CUSTOMER_COMMENT_MODIFIED_TAGGED':
            case 'CUSTOMER_COMMENT_TAGGED':
              {
                var customerTaggedVia = '';
                if (notification.content.content.groupName) {
                  customerTaggedVia = ' (' + _.i18n('common.viaGroup', null, 'via') + ' @' +
                      notification.content.content.groupName + ')';
                }
                this.displayNotification(_.i18n('notifications.customerCommentTagged'),
                    notification.content.content.initiator.firstName +
                    ' ' +
                    notification.content.content.initiator.lastName + ' ' +
                    _.i18n('common.taggedYou') + customerTaggedVia + ' ' + notification.content.content.data.endUserId,
                    '#customers/'+notification.content.entitySecId+'/details', null, null, false, notification.tag);
              }
              break;
            case 'CHAT_SESSION_STARTED':
              {
                // `data` is the ChatSessionJson at openSession time.
                // senderName/senderEmail may be null when the visitor
                // hasn't shared identity yet — fall back to a generic label.
                var startedData = notification.content.content.data || {};
                var startedName = startedData.senderName || startedData.senderEmail || 'Visitor';
                this.displayNotification(
                    _.i18n('notification.newchat'),
                    _.i18n('notification.newchat.from') + ' ' + startedName,
                    '#chat-inbox/' + notification.content.content.entitySecId,
                    7000, null, false, notification.tag);
              }
              break;
            case 'CHAT_MESSAGE_ADDED':
              {
                // Backend fires CHAT_MESSAGE_ADDED for every persisted
                // turn. Only toast on visitor-typed messages — AGENT was
                // typed by the agent themselves (or a teammate), AI/SYSTEM
                // are server-generated; none warrant a toast.
                var msgData = notification.content.content.data || {};
                if (msgData.sender === 'CUSTOMER') {
                  this.displayNotification(
                      _.i18n('notification.newchatmessage'),
                      notification.content.content.text || '',
                      '#chat-inbox/' + notification.content.content.entitySecId,
                      5000, null, false, notification.tag);
                }
              }
              break;
            case 'EMAIL_REPLY_RECEIVED':
              // "Notify me of a reply": `text` is "<sender> — <subject>". The
              // toast opens the reply in the worklist (or the mail itself when
              // no inbox reads that mailbox). Stays until clicked.
              this.displayNotification(
                  _.i18n('notifications.emailReplyReceived', null, 'Reply received'),
                  notification.content.content.text || '',
                  this.emailReplyFragment(notification.content.content),
                  null, null, false, notification.tag);
              break;
            case 'CUSTOMER_EMAIL_RECEIVED':
              // The bell of a customer file: `text` is "<customer> — <subject>".
              // Same link as a reply: the mail's inbox item over its worklist.
              this.displayNotification(
                  _.i18n('notifications.customerEmailReceived', null, 'Customer email'),
                  notification.content.content.text || '',
                  this.emailReplyFragment(notification.content.content),
                  null, null, false, notification.tag);
              break;
            case 'CALENDAR_REMINDER':
              // `text` is already a full sentence ("Reminder: <title>").
              this.displayNotification(
                  _.i18n('notification.calendar.reminder', null, 'Reminder'),
                  notification.content.content.text || '',
                  '#calendar', 7000, null, false, notification.tag);
              break;
            case 'CALENDAR_VACATION_APPROVAL_REQUEST':
            case 'CALENDAR_VACATION_APPROVED':
            case 'CALENDAR_VACATION_REJECTED':
            case 'CALENDAR_GROUP_EVENT':
              this.displayNotification(
                  _.i18n('notification.calendar', null, 'Calendar'),
                  notification.content.content.text || '',
                  '#calendar', 7000, null, false, notification.tag);
              break;
          }
          break;
      }
    },

    // Where an EMAIL_REPLY_RECEIVED / CUSTOMER_EMAIL_RECEIVED notification
    // leads. The mail is notified when it is stored, before its classification:
    // the route looks its inbox item up on click and opens it over its
    // worklist, or opens the mail itself when it is in no inbox.
    emailReplyFragment: function (content) {
      var data = (content && content.data) || {};
      if (data.emailAddressSecId && data.messageId) {
        return '#sales-inbox/mail/' + data.emailAddressSecId + '/' + encodeURIComponent(data.messageId);
      }
      return '#sales-inbox/worklist';
    },

    removeListener: function (view, event, callback) {
      this.off(event, callback, view);
    },

    addListener: function (view, event, callback) {
      this.on(event, callback, view);
      view.listenTo(view, 'before:destroy', _.bind(function () {
        this.off(event, callback, view);
      }, this));
    },

    displayNotification: function (title, message, urlFromFragment, hideDelay, type, forceJsNotification, tag) {
      var fullUrl = document.location.origin + document.location.pathname + urlFromFragment;
      if (window.Notification && window.Notification.permission === 'granted' && !forceJsNotification) {
        var options = {
          body: message ? message.replace(new RegExp('<br>', 'g'), ' ') : '',
          icon: Settings.url('base', Settings.get('defaultLogo')),
          tag: tag
        };

        var notification = new window.Notification(title, options);
        notification.onclick = function () {
          window.location = fullUrl;
          window.focus();
        };
        if (hideDelay) {
          notification.onshow = function () {
            window.setTimeout(function () {
              notification.close();
            }, hideDelay);
          };
        }
      } else {
        $.notify({
          title: title,
          message: message,
          url: fullUrl,
          target: '_self',
          autoHide: !!hideDelay,
          autoHideDelay: hideDelay
        }, {
          type: type || 'info',
          placement: {
            from: 'top',
            align: 'center'
          }
        });
      }
    }
  });

  var getInstance = function () {
    if (!instance) {
      instance = new NotificationCenter();
    }
    return instance;
  };

  module.exports = NotificationCenter;
  module.exports.getInstance = getInstance;
  module.exports.events = events;
});

